import script from "./Search.vue?vue&type=script&setup=true&lang=js"
export * from "./Search.vue?vue&type=script&setup=true&lang=js"

import "./Search.vue?vue&type=style&index=0&id=60e0774e&scoped=true&lang=css"

import exportComponent from "C:\\xampp8\\htdocs\\arm_analysis_2025_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e0774e"]])

export default __exports__